var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2_svg__a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogdXJsKCNsaW5lYXItZ3JhZGllbnQpOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHgxPSIyMy41ODEiIHkxPSI0OCIgeDI9IjI0LjQxOSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiM0MjU2ZmYiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODBhOWZmIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIvPgo8L3N2Zz4K",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    preserveAspectRatio: "none",
    result: "image"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "composite"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    result: "blend"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M-.011 2.175v34.059l23.8 11.756 24.2-11.756V-.013h-48z",
    "data-name": "\\u5F62\\u72B6 26 \\u62F7\\u8D1D",
    style: {
      fill: "#f9130b",
      fillRule: "evenodd",
      filter: "url(#2_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": 2,
    style: {
      fontSize: 35,
      fill: "#fff",
      fontFamily: "&quot"
    },
    transform: "matrix(.96 0 0 .98 14.492 33.819)"
  }, "2"));
};
export default Svg2;